module.exports = __webpack_public_path__ + "img/truck.176fe3b7.jpeg";